function updateSelectedCountFromInput(input) {
  const submenu = input.closest('.mobile-facets__submenu');
  if (!submenu) return;

  const counter = submenu.querySelector('[data-selected-count]');
  if (!counter) return;

  const checked = submenu.querySelectorAll(
    'input[type="checkbox"]:checked'
  ).length;

  counter.textContent = `${checked} selected`;
}

document.addEventListener('change', (event) => {
  const input = event.target;

  if (
    input.matches(
      '.mobile-facets__checkbox, .facets__checkbox, input[type="checkbox"]'
    )
  ) {
    updateSelectedCountFromInput(input);
  }
});


/* Handle Clear / Reset */
document.addEventListener('click', (event) => {
  const clear = event.target.closest('.mobile-facets__clear');
  if (!clear) return;

  const submenu = clear.closest('.mobile-facets__submenu');
  if (!submenu) return;

  const counter = submenu.querySelector('[data-selected-count]');
  if (!counter) return;

  counter.textContent = `0 selected`;
});



(function () {
  const STORAGE_KEY = 'collection_layout';

  function applyLayout(layout) {
    const container = document.getElementById('ProductGridContainer');
    if (!container) return;

    if (layout === 'list') {
      container.setAttribute('data-layout', 'list');
    } else {
      container.removeAttribute('data-layout');
    }

    document.querySelectorAll('.layout-btn').forEach(btn => {
      btn.classList.toggle('active', btn.dataset.layout === layout);
    });

    localStorage.setItem(STORAGE_KEY, layout);
  }

  // Initial load
  applyLayout(localStorage.getItem(STORAGE_KEY) || 'grid');

  // Click handling
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.layout-btn');
    if (!btn) return;
    applyLayout(btn.dataset.layout);
  });

  // After filters reload (AJAX)
  document.addEventListener('shopify:section:load', function () {
    applyLayout(localStorage.getItem(STORAGE_KEY) || 'grid');
  });
})();


// Phone js 
// form.addEventListener('submit', function (e) {
//   let existingError = form.querySelector('.phone-error');
//   if (existingError) existingError.remove();

//   const phoneValue = phoneInput.value.trim();

//   if (phoneValue.length !== 10) {
//     e.preventDefault();

//     const error = document.createElement('div');
//     error.className = 'phone-error';
//     error.style.color = 'red';
//     error.style.fontSize = '13px';
//     error.style.marginTop = '5px';
//     error.textContent = 'Please enter a valid 10-digit phone number.';

//     phoneInput.parentNode.appendChild(error);
//     phoneInput.focus();
//   }
// });


document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-desc-toggle').forEach(toggle => {
    toggle.addEventListener('click', function() {
      const wrapper = this.closest('.product-desc-collapsible');
      wrapper.classList.toggle('expanded');
      this.textContent = wrapper.classList.contains('expanded')
        ? 'Read less'
        : 'Read more';
    });
  });
});


document.addEventListener("DOMContentLoaded", function () {

  const form = document.querySelector(".contact-vaidya-popup");
  const phoneInput = document.querySelector('input[name="contact[phone]"]');
  const phoneError = document.getElementById("error-phone");

  // Allow only numbers while typing
  phoneInput.addEventListener("input", function () {
    this.value = this.value.replace(/\D/g, "");

    // Limit to 10 digits
    if (this.value.length > 10) {
      this.value = this.value.slice(0, 10);
    }

    // Hide error while typing correctly
    if (/^\d{10}$/.test(this.value)) {
      phoneError.style.display = "none";
    }
  });

  // Form submit validation
  document.querySelector(".submit-btn").addEventListener("click", function (e) {

    const phoneValue = phoneInput.value.trim();

    // Validate 10 digit number
    if (!/^\d{10}$/.test(phoneValue)) {
      e.preventDefault();
      phoneError.style.display = "block";
      phoneInput.focus();
      return false;
    } else {
      phoneError.style.display = "none";
    }

  });

});

